import { Menu, MenuItem } from '@mui/material';
import React from 'react';

const ResourceMenu = ({ resourceMenu, handleClose, handleChangeSortEnability, handleOpenColorDialog }) => {
  return (
    <Menu
      id="basic-menu"
      anchorReference="anchorPosition"
      anchorPosition={
        Boolean(resourceMenu.position)
          ? { top: resourceMenu.position.mouseY, left: resourceMenu.position.mouseX }
          : undefined
      }
      open={Boolean(resourceMenu.position)}
      onClose={handleClose}
    >
      <MenuItem onClick={() => handleChangeSortEnability('project')}>Projekt sorrend szerkesztése</MenuItem>
      <MenuItem onClick={handleOpenColorDialog}>Színválasztó</MenuItem>
      <MenuItem onClick={() => handleChangeSortEnability('employee')}>Erőforrás sorrend szerkesztése</MenuItem>
    </Menu>
  );
};

export default ResourceMenu;
